import { Section } from './Section';
import { ImageComposition } from '@app/shared/ui/molecules/Instructions';
import { firstStoneImage, secondStoneImage, fourthStoneImage } from '@app/assets';

export function StonesSection() {
  return (
    <Section
      img={
        <ImageComposition
          firstSrc={firstStoneImage}
          firstAlt="first stone"
          secondSrc={secondStoneImage}
          secondAlt="second stone"
          thirdSrc={fourthStoneImage}
          thirdAlt="third stone"
          isSideImagesOpaque={false}
        />
      }
      titleTranslationKey="stones_title"
      descriptionTranslationKey="stones_text"
    />
  );
}
